import "core-js/modules/es.array.concat.js";
import { asyncImportScript } from 'integration-web-core--socle/js/assets/modules/_asyncImportScript';
import VideoCore from 'integration-web-core--socle/js/assets/modules/_video.class';
export default (function () {
  var youtubeVideos = document.querySelectorAll('.video-js.video-js--youtube');
  var brightcoveVideos = document.querySelectorAll('.video-js:not(.video-js--youtube)');
  var hasYoutubeVideo = youtubeVideos.length > 0;
  var hasBrightcoveVideo = brightcoveVideos.length > 0;
  if (hasYoutubeVideo) {
    new VideoCore();
  }
  if (hasBrightcoveVideo) {
    var _brightcoveVideos$0$d = brightcoveVideos[0].dataset,
      account = _brightcoveVideos$0$d.account,
      player = _brightcoveVideos$0$d.player;
    asyncImportScript("//players.brightcove.net/".concat(account, "/").concat(player, "_default/index.min.js"));
  }
});